import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconCancel } from '@at.govt.nz/vector/lib/img/icon-cancel.svg';
import { ReactComponent as IconLive } from '../../../../assets/svg/icon-live.svg';
import { getIcon } from './helpers';

const DisplayIcon = ({ mode, isLive, cancelled }) => {
  const {
    SvgIcon,
    iconClass,
  } = getIcon(mode);

  if (!SvgIcon) {
    return null;
  }
  const iconLive = isLive && <IconLive className="movement-info-icon-live" role="img" />;
  const iconCancelled = cancelled && <IconCancel className="movement-info-icon-cancelled" role="img" />;
  return (
    <div className={`movement-info-img-container ${mode === 'TRAIN' ? 'movement-info-img-container-train' : ''}`} aria-hidden="true">
      <SvgIcon className={`movement-info-icon ${iconClass}`} role="img" />
      {iconLive}
      {iconCancelled}
    </div>
  );
};
DisplayIcon.propTypes = {
  mode: PropTypes.string,
  isLive: PropTypes.bool,
  cancelled: PropTypes.bool,
};
DisplayIcon.defaultProps = {
  mode: null,
  isLive: false,
  cancelled: false,
};

export default DisplayIcon;